module.exports = __webpack_public_path__ + "img/logo-atlassian.0569965a.svg";